export default "__VITE_PUBLIC_ASSET__29f1b0f2__"